import React, { Component } from "react";

import { Provider } from "react-redux";
import store from "./store";
import { loadUser } from "./actions/authActions";
import Login from "./components/auth/Login";

import "bootstrap/dist/css/bootstrap.min.css";

import "./App.css";

class App extends Component {
  componentDidMount() {
    store.dispatch(loadUser());
  }

  render() {
    return (
      <Provider store={store}>
        <div className="App">
          <Login />
        </div>
      </Provider>
    );
  }
}

export default App;
